// test1541
(1541 && 0);
